<template>
  <div class="input-group date-picker">
    <input class="form-control date-picker-notbefore" :id="'notBeforeDate' + removeSpecialSymboy(item.userId)" name="sdate" type="text" v-on:blur="checkEditDate"/>
    <span class="input-group-addon icon_date_notbefore">
      <i class="fa fa-calendar bigger-110"></i>
    </span>
    <input type="text" name="tdate" class="form-control" :id="'notBeforeTime' + removeSpecialSymboy(item.userId)" v-on:blur="checkEditTime"/>
    <span class="input-group-addon">
      <i class="fa fa-clock-o bigger-110"></i>
    </span>
  </div>
</template>

<script>

export default {
  props: ['item'],
  data () {
    return {
    }
  },
  methods: {
    checkEditDate () {
      var vm = this
      $('.datepicker table tr td.day').click(function () {
        vm.updateEditStatus()
      })
    },
    checkEditTime () {
      var vm = this
      $('.bootstrap-timepicker-widget table tr td a').click(function () {
        vm.updateEditStatus()
      })
    },
    updateEditStatus () {
      this.$emit('edited')
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/gate/DatePickerBefore.vue